<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="prefixNo"
                  label="Enter Prefix No"
                  v-model="accountHead.prefixNo"
                  :rules="rules.prefixNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="accountName"
                  label="Enter Account Head Name"
                  v-model="accountHead.accountName"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex sm6>
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex> -->
              <v-flex sm12 v-if="accountHead.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="accountHead.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="accountHead.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="accountHead.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="accountHead.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="accountHead.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { accountHeadService } from "../../services/account-head-service";
import { AccountHead } from "../../models/model";
import { AccountHeadFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "AccountHeadDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Account Head",
        disabled: false,
        to: "accountheads"
      },
      {
        text: "Account Head Detail",
        disabled: true
      }
    ],
    statusFlag: true,
    updatedDate: "",
    createdDate: "",
    accountHead: new AccountHead(),
    oldAccountHead: new AccountHead(),
    saveLoading: false,
    responseError: "",
    rules: new AccountHeadFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    console.log(id);
    if (id == "new") {
      // new accountHead
    } else {
      this.getAccountHeadDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        this.accountHead.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        accountHeadService
          .saveAccountHead(this.accountHead)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getAccountHeadDetail(id) {
      accountHeadService
        .getAccountHeadDetail(id)
        .then(res => {
          this.accountHead = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.accountHead.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.accountHead.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.statusFlag = this.accountHead.status == 'ACTIVE' ? true : false;
          this.oldAccountHead = Object.assign({}, res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.accountHead.id) {
        this.accountHead = new AccountHead();
        this.statusFlag = true;
      } else {
        this.accountHead = Object.assign({}, this.oldAccountHead);
        this.statusFlag = this.accountHead.status == 'ACTIVE' ? true : false;
      }
    },
    goBack() {
      this.$router.push("/accountheads");
    }
  }
};
</script>
